import { ChangeEvent, FocusEvent, ReactNode } from 'react';
import { Tooltip } from 'react-tooltip';
import './index.css';

interface IProps {
  placeholder?: string;
  title?: string | ReactNode;
  className?: string;
  type?: string;
  id?: string;
  onChange?: (value: string) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  value?: string;
  rightIcon?: string;
  onRightIconClick?: () => void;
  arrowRightClassName?: string;
  titleClassName?: string;
  disabled?: boolean;
  maxLength?: number;
  isBlueBg?: boolean;
  isBlueText?: boolean;
  isGreyText?: boolean;
  hasTooltip?: string | null | ReactNode;
  tooltipId?: string;
  redBorder?: boolean;
  wrapperCn?: string;
}

const Input = ({
  placeholder = '',
  title = '',
  className = '',
  type = 'text',
  id,
  onChange,
  onBlur,
  value,
  rightIcon,
  onRightIconClick,
  arrowRightClassName,
  titleClassName = '',
  disabled = false,
  maxLength,
  isBlueBg = false,
  hasTooltip = null,
  isBlueText = false,
  isGreyText = false,
  redBorder = false,
  tooltipId = '',
  wrapperCn = '',
  ...props
}: IProps) => {
  const onInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange?.(e.target.value);
  };

  return (
    <div className={`relative ${wrapperCn}`}>
      {title && (
        <div
          className={`${titleClassName} absolute text-secondaryText bg-[#fff] rounded left-6 top-1 text-sm ${
            isBlueBg ? 'bg-blue-gradient' : ''
          }`}
          data-tooltip-id={tooltipId}
        >
          {title}
        </div>
      )}
      {hasTooltip && (
        <Tooltip
          id={tooltipId}
          place="bottom-start"
          className="tooltip"
          variant="light"
          noArrow
        >
          {hasTooltip}
        </Tooltip>
      )}
      <input
        id={id}
        className={`${
          disabled
            ? 'cursor-not-allowed bg-[#EEEEEE]'
            : isBlueBg
              ? 'bg-primitiveBlue'
              : 'bg-inherit'
        } ${
          isBlueText
            ? 'text-primary'
            : isGreyText
              ? 'text-secondaryText'
              : 'text-black'
        } p-2.5 text-base rounded-xl border ${
          redBorder
            ? 'border-red500 focus:border-red500 focus:outline-none active:border-red500'
            : 'border-[#CBCBCB] focus:border-[#007AC1] focus:outline-none active:border-[#007AC1]'
        }  h-[48px]  ${className}`}
        placeholder={placeholder}
        type={type}
        onChange={onInputChange}
        onBlur={onBlur}
        value={value}
        disabled={disabled}
        maxLength={maxLength}
        {...props}
      />
      {rightIcon && (
        <div
          onClick={onRightIconClick}
          className={`${arrowRightClassName} absolute cursor-pointer`}
        >
          <img src={rightIcon} alt="rightIcon" />
        </div>
      )}
    </div>
  );
};

export default Input;
